import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

// Async thunk for fetching view metrics
export const viewMetricsAction = createAsyncThunk(
    "viewMetrics",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.viewMetrics, payload);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const viewMetricsSlice = createSlice({
    name: "viewMetrics",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: null,
    },
    reducers: {
        viewMetricsReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: null,
            };
        },
    },
    extraReducers: {
        [viewMetricsAction.pending]: (state) => {
            state.isLoading = true;
            state.data = null;
            state.error = null;
        },
        [viewMetricsAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.data = payload;
            state.error = null;
        },
        [viewMetricsAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    },
});

export const { viewMetricsReset } = viewMetricsSlice.actions;
export default viewMetricsSlice.reducer;
